<div class="wrapper">
    <div class="header">
        <div class="title-row">
            <div class="title">{{ title }}</div>

            @if(isSingleServiceRequest && canAddSpecimen && !editingLockedByServiceRequestCompletion){
            <button mat-stroked-button (click)="addSpecimen()" [disabled]="adding">
                <mat-icon>add</mat-icon>
                Add Specimen
            </button>
            }
        </div>

        @if(editingLockedByServiceRequestCompletion){
        <div class="subtitle" style="margin-top: 6px;">
            This Service Request is completed. Editing actions are disabled.
        </div>
        }

        @if(!isSingleServiceRequest){
        <div class="subtitle">
            Selection only. If you need to create a new specimen, close this dialog and add it from the relevant Lab
            Request.
        </div>
        }
    </div>

    @if(loading){
    <div class="loading">
        <mat-spinner diameter="36"></mat-spinner>
        <span>Loading specimens…</span>
    </div>
    }

    @if(!loading && dataSource.data.length === 0){
    <div class="empty">
        No specimen found for the selected Service Request(s).
    </div>
    }

    @if(!loading && dataSource.data.length > 0){
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

        @if(forSelection){
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)"
                    [disabled]="!row.status || row.status.toLowerCase() !== 'available'">

                </mat-checkbox>
            </td>
        </ng-container>
        }

        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">{{ getType(row) }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
                @if(row.status){
                <div [appChips]="row.status" [fontSize]="'14px'"></div>
                } @else {
                <span class="subtitle-text-color-2">N/A</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="receivedTime">
            <th mat-header-cell *matHeaderCellDef>Received</th>
            <td mat-cell *matCellDef="let row">
                <div class="g-just-flex flex-column align-items-start">
                    <span>{{ row.receivedTime | date : 'mediumDate' | na }}</span>

                </div>
                <div class="bottom subtitle-text-color-2">
                    <span>{{ row.receivedTime | date : 'shortTime' | na }}</span>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
                <div class="row-actions">
                    <button mat-stroked-button [matMenuTriggerFor]="statusMenu" [matMenuTriggerData]="{ row: row }"
                        (click)="$event.stopPropagation()"
                        [disabled]="editingLockedByServiceRequestCompletion || isUpdatingStatus(row) || !canEditSpecimen || !row?.id"
                        matTooltip="Change specimen status">
                        <mat-icon>sync</mat-icon>

                    </button>
                    <button mat-stroked-button matTooltip="Print specimen label" matTooltipPosition="above"
                        (click)="$event.stopPropagation(); printLabel(row)" [disabled]="!row?.id">
                        <mat-icon>print</mat-icon>

                    </button>
                </div>
            </td>
        </ng-container>

        <mat-menu #statusMenu="matMenu">
            <ng-template matMenuContent let-row="row">
                <button mat-menu-item (click)="requestSetStatus(row, 'available')"
                    [disabled]="editingLockedByServiceRequestCompletion || isUpdatingStatus(row)">
                    Available
                </button>
                <button mat-menu-item (click)="requestSetStatus(row, 'unavailable')"
                    [disabled]="editingLockedByServiceRequestCompletion || isUpdatingStatus(row)">
                    Unavailable
                </button>
                <button mat-menu-item (click)="requestSetStatus(row, 'unsatisfactory')"
                    [disabled]="editingLockedByServiceRequestCompletion || isUpdatingStatus(row)">
                    Unsatisfactory
                </button>
                <button mat-menu-item (click)="requestSetStatus(row, 'entered-in-error')"
                    [disabled]="editingLockedByServiceRequestCompletion || isUpdatingStatus(row)">
                    Entered-in-error
                </button>
            </ng-template>
        </mat-menu>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
    </table>
    }

    <div class="actions">
        @if(forSelection){
        <button mat-stroked-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" (click)="confirm()" [disabled]="selection.selected.length === 0">
            <mat-icon>check</mat-icon>
            Use Selected ({{ selection.selected.length }})
        </button>
        } @else {
        <button mat-stroked-button (click)="close()">Close</button>
        }
    </div>
</div>